/*
 * BRANDJUNG Custom JavaScript
 * =========================================================
 */

/* BRANDJUNG custom code start
   Custom range filter web component for list-type filters with numeric values.
   Renders a dual-range slider and toggles hidden checkboxes based on the
   selected range, so Shopify's standard faceting form submission works.
   BRANDJUNG custom code end */
class CustomRangeFilter extends HTMLElement {
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();
    const signal = this.#abortController.signal;

    const rangeLowerBound = this.querySelector('input[type="range"]:first-child');
    const rangeHigherBound = this.querySelector('input[type="range"]:last-child');
    const textInputLowerBound = this.querySelector('input[data-range-bound="lower"]');
    const textInputHigherBound = this.querySelector('input[data-range-bound="upper"]');
    const checkboxes = this.querySelectorAll('.custom-range-filter__checkboxes input[type="checkbox"]');

    if (!rangeLowerBound || !rangeHigherBound || !textInputLowerBound || !textInputHigherBound) return;

    const min = parseInt(rangeLowerBound.min);
    const max = parseInt(rangeLowerBound.max);
    const range = max - min || 1;

    const updateTrack = () => {
      const lowerVal = parseInt(rangeLowerBound.value);
      const upperVal = parseInt(rangeHigherBound.value);
      rangeLowerBound.parentElement.style.setProperty('--range-min', `${(lowerVal - min) / range * 100}%`);
      rangeLowerBound.parentElement.style.setProperty('--range-max', `${(upperVal - min) / range * 100}%`);
    };

    const updateCheckboxes = () => {
      const lowerVal = parseInt(textInputLowerBound.value);
      const upperVal = parseInt(textInputHigherBound.value);
      checkboxes.forEach((cb) => {
        const val = parseFloat(cb.dataset.numericValue);
        cb.checked = val >= lowerVal && val <= upperVal;
      });
    };

    textInputLowerBound.addEventListener('focus', () => textInputLowerBound.select(), { signal });
    textInputHigherBound.addEventListener('focus', () => textInputHigherBound.select(), { signal });

    textInputLowerBound.addEventListener('change', (event) => {
      event.preventDefault();
      const upperVal = parseInt(textInputHigherBound.value || max);
      event.target.value = Math.max(Math.min(parseInt(event.target.value), upperVal), min);
      rangeLowerBound.value = event.target.value;
      updateTrack();
      updateCheckboxes();
    }, { signal });

    textInputHigherBound.addEventListener('change', (event) => {
      event.preventDefault();
      const lowerVal = parseInt(textInputLowerBound.value || min);
      event.target.value = Math.min(Math.max(parseInt(event.target.value), lowerVal), max);
      rangeHigherBound.value = event.target.value;
      updateTrack();
      updateCheckboxes();
    }, { signal });

    rangeLowerBound.addEventListener('change', (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      updateCheckboxes();
      textInputLowerBound.dispatchEvent(new Event('change', { bubbles: true }));
    }, { signal });

    rangeHigherBound.addEventListener('change', (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      updateCheckboxes();
      textInputHigherBound.dispatchEvent(new Event('change', { bubbles: true }));
    }, { signal });

    rangeLowerBound.addEventListener('input', (event) => {
      const upperVal = parseInt(rangeHigherBound.value);
      event.target.value = Math.min(parseInt(event.target.value), upperVal);
      textInputLowerBound.value = event.target.value;
      updateTrack();
    }, { signal });

    rangeHigherBound.addEventListener('input', (event) => {
      const lowerVal = parseInt(rangeLowerBound.value);
      event.target.value = Math.max(parseInt(event.target.value), lowerVal);
      textInputHigherBound.value = event.target.value;
      updateTrack();
    }, { signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }
}

if (!window.customElements.get('custom-range-filter')) {
  window.customElements.define('custom-range-filter', CustomRangeFilter);
}
